import objectAddress from "@/model/address";
import objectUser from "@/model/user";
import {
  STEP_STATUS,
  ORDER_TYPE,
  PiCKUP_TIME,
  STEPS,
} from "../utilities/enums";

const cartObject = {
  locationId: null,
  newOrder: null,
  card_id: null,
  save_card: false,
  card: null,
  status: STEP_STATUS.PREPARED,
  user: objectUser,
  order: [],
  orderType: ORDER_TYPE.Delivery.id, //Delivery , PickUp , Table
  total: 0,
  comment: "",
  driver_instructions: "",
  delivery_fee: 0,
  orderTotal: 0,
  coupon_result: null,
  coupon_error: null,
  coupon: "",
  pickUp: {
    //---- ASAP / Later
    type: PiCKUP_TIME.ASAP,
    date: null,
    time: null,
  },
  address: objectAddress,
  payment_type: null,
  table: null,
  payment_intent: null,
  headers: null, // received stripe headers from the api
  step: STEPS.STEP01,
  service_charge: 0,
  bag_charge: 0,
  postCode: null,
  is_deliverect:0
};
export default Object(cartObject);
